module.exports = __webpack_public_path__ + "img/sofia-homepage.ed659c49.png";